import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_GLOSSARY } from "../domain";

import { glossaryApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_DELETE_GLOSSARY = "DELETE_GLOSSARY";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

type DeleteGlossaryRequest = string;

const deleteGlossary = async (id: DeleteGlossaryRequest): Promise<void> => {
  await glossaryApi.glossaryControllerDeleteGlossaryTerm(id);
};

export const useDeleteGlossaryTerm = (
  user: UserProfileDto | null,
): {
  deleteGlossary: UseMutateFunction<void, Error, DeleteGlossaryRequest, unknown>;
  deleteGlossaryEnabled: boolean;
  isSuccessDeleteGlossary: boolean;
  isPendingDeleteGlossary: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_GLOSSARY, ACTION_DELETE_GLOSSARY],
    mutationFn: enabled ? deleteGlossary : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_GLOSSARY] });
    },
  });

  return {
    deleteGlossary: mutate,
    deleteGlossaryEnabled: enabled,
    isSuccessDeleteGlossary: isSuccess,
    isPendingDeleteGlossary: isPending,
  };
};
